const GA_MEASUREMENT_ID = 'G-8Q9ES1009T'

const gtag = (...args) => {
  if (process.env.NODE_ENV === 'production' && typeof window.gtag === 'function') {
    window.gtag(...args)
  }
}

const trackPageView = (route) => {
  gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: route.fullPath,
    send_to: GA_MEASUREMENT_ID
  })
}

const trackEvent = (category, action, label, value) => {
  gtag('event', action, {
    event_category: category,
    event_label: label,
    value
  })
}

export const initGoogleAnalytics = (Vue, router) => {
  Vue.prototype.$ga = { event: trackEvent }
  router.afterEach(trackPageView)
}
